/**
 * OVERRIDE Form.jsx
 */

import Form from '../../../../components/Form/Form';

export default Form;